import axios from 'axios';
import md5 from 'md5';

import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGOUT,
  AUTH_GET_STATUS,
  AUTH_GET_STATUS_FAILURE,
  AUTH_GET_STATUS_SUCCESS,
} from './ActionTypes';

// LOGIN
export const loginRequest = (email, password) => {
  const hashedPassword = md5(password+"{"+email+"}");

  return (dispatch) => {
    dispatch(login());

    return axios.post('/api/account/signin', { email: email, password: hashedPassword })
    .then((response) => {
      dispatch(loginSuccess(email, response.data.role));
    }).catch((error) => {
      dispatch(loginFailure());
    });
  };
}

export const login = () => {
  return {
    type: AUTH_LOGIN
  };
}

export const loginSuccess = (email, role) => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    email,
    role
  };
}

export const loginFailure = () => {
  return {
    type: AUTH_LOGIN_FAILURE
  }
}

/* LOGOUT */
export const logoutRequest = () => {
  return (dispatch) => {
    return axios.post('/api/account/logout')
    .then((response)=>{
      dispatch(logout());
    });
  };
}

export const logout = () => {
  return {
    type: AUTH_LOGOUT
  };
}

/* GET STATUS */

export const getStatusRequest = () => {
  return (dispatch) => {
      // inform Get Status API is starting
      dispatch(getStatus());

      return axios.get('/api/account/getinfo')
      .then((response) => {
          dispatch(getStatusSuccess(response.data.info.email, response.data.info.role)); //HTTP 틍신을 통해 username을 빋이옴
      }).catch((error) => {
          dispatch(getStatusFailure());
      });
  };
}

export const getStatus = () => {
  return {
    type: AUTH_GET_STATUS
  };
}

export const getStatusSuccess = (email, role) => {
  return {
    type: AUTH_GET_STATUS_SUCCESS,
    email,
    role
  };
}

export const getStatusFailure = () => {
  return {
    type: AUTH_GET_STATUS_FAILURE
  };
}
